import ContactCard from "../../../../../component/contact_card";

const ContactDetails = () => {
  return (
    <>
      <div className="container pb-5 mt-6">
        <div>
          <h4 className="mb-4 border-bottom text-primary pb-2">Sales RM </h4>
          <div className="row">
            <div className="col-md-4">
              <ContactCard
                image="/assets/images/profile_img.jpg"
                name="Umesh Kohli"
                contact="9090009099"
                email="umesh.kohli@pincinsure.com"
              />
            </div>
          </div>
        </div>

        <div>
          <h4 className="my-4 border-bottom text-primary pb-2">Service RM </h4>
          <div className="row">
            <div className="col-md-4">
              <ContactCard
                image="/assets/images/profile_img.jpg"
                name="Kashmira Thakur - level 1"
                contact="9920602670"
                email="Kashmira.thakur@pincinsure.com"
              />

            </div>
            <div className="col-md-4">
              <ContactCard
                image="/assets/images/profile_img.jpg"
                name="Prakash Nayak - level 2"
                contact="8657561714"
                email="prakash.nayak@pincinsure.com"
              />
            </div>
          </div>
        </div>

        <div>
          <h4 className="my-4 border-bottom text-primary pb-2">Support RM</h4>
          <div className="row pb-5">
            <div className="col-md-4">
              {/* <ContactCard
                image="/assets/images/profile_img.jpg"
                name="Darshan Rahate (Claims)"
                contact="9987243787"
                email="darshan.rahate@pincinsure.com"
              /> */}
              <ContactCard
                image="/assets/images/profile_img.jpg"
                name="Rutwij Sawant (Claims)"
                contact="9819134545"
                email=" rutwij.sawant@pincinsure.com"
              />
            </div>
            <div className="col-md-4">
              <ContactCard
                image="/assets/images/profile_img.jpg"
                name="Poonam Jain (IT) "
                contact="9833227562"
                email="poonam.jain@pincinsure.com"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactDetails;
